var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.25C7.30234 0.25 0.25 7.30234 0.25 16C0.25 24.6977 7.30234 31.75 16 31.75C24.6977 31.75 31.75 24.6977 31.75 16C31.75 7.30234 24.6977 0.25 16 0.25ZM22.8027 10.8566L15.3988 21.1223C15.2953 21.2667 15.1589 21.3844 15.0009 21.4656C14.8428 21.5468 14.6677 21.5891 14.49 21.5891C14.3124 21.5891 14.1372 21.5468 13.9792 21.4656C13.8211 21.3844 13.6847 21.2667 13.5813 21.1223L9.19727 15.0473C9.06367 14.8609 9.19727 14.6008 9.42578 14.6008H11.0746C11.4332 14.6008 11.7742 14.773 11.9852 15.0684L14.4883 18.5418L20.0148 10.8777C20.2258 10.5859 20.5633 10.4102 20.9254 10.4102H22.5742C22.8027 10.4102 22.9363 10.6703 22.8027 10.8566V10.8566Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16,
    y1: 0.25,
    x2: 16,
    y2: 31.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B25FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.463f0729fea667ee548fd119dfb96709.svg";
export { ForwardRef as ReactComponent };